import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const FAQItem = ({
  question,
  answer
}: {
  question: string;
  answer: string;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-brand-green/20 last:border-0" data-id="element-58">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full text-left py-6 flex justify-between items-center focus:outline-none group" data-id="element-59">
        <h4 className="text-lg font-serif font-bold text-brand-charcoal group-hover:text-brand-green transition-colors" data-id="element-60">
          {question}
        </h4>
        <div className={`ml-4 flex-shrink-0 w-6 h-6 rounded-full border border-brand-green flex items-center justify-center transition-transform duration-300 ${isOpen ? 'bg-brand-green text-white rotate-180' : 'text-brand-green'}`} data-id="element-61">
          <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-62">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" data-id="element-63" />
          </svg>
        </div>
      </button>
      <AnimatePresence data-id="element-64">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} className="overflow-hidden" data-id="element-65">
            <p className="pb-6 text-brand-charcoal/80 leading-relaxed" data-id="element-66">
              {answer}
            </p>
          </motion.div>}
      </AnimatePresence>
    </div>;
};
export const FAQSection = () => {
  const faqs = [{
    question: '¿Tengo que comprar suplementos caros?',
    answer: 'No. Te enseñamos cuáles funcionan, pero la base es la nutrición informativa que compras en cualquier super.'
  }, {
    question: '¿Funciona si ya pasé la menopausia?',
    answer: 'Sí, los principios de resiliencia metabólica son vitales para la salud ósea y cardiovascular post-menopausia.'
  }];
  return <section className="py-8 px-4 md:px-8 bg-brand-creamAlt" data-id="element-67">
      <div className="max-w-3xl mx-auto" data-id="element-68">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-69">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-charcoal text-center mb-10" data-id="element-70">
            Preguntas Frecuentes
          </h2>

          <div className="bg-white rounded-2xl p-6 md:p-8 shadow-sm" data-id="element-71">
            {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} data-id="element-72" />)}
          </div>
        </motion.div>
      </div>
    </section>;
};